<script lang="ts">
  import type { GalleryFiltersSchema } from '$src/utils/api/feed.util';
  import DefaultDropdown from '$lib/components/common/dropdowns/Default.svelte';
  import type { Dict } from 'garden-common';

  export let detail: GalleryFiltersSchema['galleryType'];
  export let isValid: boolean = true;

  const options: Dict<GalleryFiltersSchema['galleryType']> = {
    'Posts Only': 'posts',
    'People Only': 'talents'
  };

  let value = null;

  $: isValid = value !== null;
  $: detail = options[value];
</script>

<DefaultDropdown
  bind:value
  placeholder="Select a gallery type"
  label="Gallery Type"
  danger={!isValid}
  options={Object.keys(options)}
  class="z-[100]"
/>
